import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';

// ฟังก์ชันสำหรับ debug ข้อมูลน้องๆ ในฐานข้อมูล
export const debugGirlData = async () => {
  try {
    console.log('🔍 เริ่มตรวจสอบข้อมูลน้องๆ ในฐานข้อมูล...');
    
    const girlsRef = collection(db, 'girls');
    const snapshot = await getDocs(girlsRef);
    
    if (snapshot.empty) {
      console.log('❌ ไม่มีข้อมูลน้องๆ ในฐานข้อมูล');
      return;
    }
    
    console.log(`📊 พบข้อมูลน้องๆ ${snapshot.docs.length} คน`);
    
    snapshot.docs.forEach((doc, index) => {
      const data = doc.data();
      console.log(`\n👧 น้องที่ ${index + 1}: ${data.nickname || 'ไม่มีชื่อ'}`);
      console.log('📋 ข้อมูลที่มี:');
      console.log('  - subscription:', data.subscription || '❌ ไม่มี');
      console.log('  - description:', data.description || '❌ ไม่มี');
      console.log('  - momoName:', data.momoName || '❌ ไม่มี');
      console.log('  - type:', data.type || '❌ ไม่มี');
      console.log('  - grades:', data.grades || '❌ ไม่มี');
      console.log('  - bio:', data.bio || '❌ ไม่มี');
      console.log('  - userId:', data.userId || '❌ ไม่มี');
      console.log('  - คำอธิบาย (description):', data.description || '❌ ไม่มี');
      console.log('  - คำอธิบาย (bio):', data.bio || '❌ ไม่มี');
      
      // แสดงฟิลด์ทั้งหมดที่มี
      console.log('📝 ฟิลด์ทั้งหมดที่มี:');
      Object.keys(data).forEach(key => {
        console.log(`    - ${key}:`, data[key]);
      });
    });
    
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    
  } catch (error) {
    console.error('❌ ไม่สามารถตรวจสอบข้อมูล:', error);
    return null;
  }
};

// ฟังก์ชันสำหรับแสดงข้อมูลน้องๆ ในรูปแบบตาราง
export const displayGirlDataTable = async () => {
  try {
    const girlsData = await debugGirlData();
    
    if (!girlsData) {
      console.log('❌ ไม่สามารถดึงข้อมูลได้');
      return;
    }
    
    console.log('\n📊 สรุปข้อมูลน้องๆ:');
    console.table(girlsData.map(girl => ({
      nickname: girl.nickname || 'ไม่มีชื่อ',
      subscription: girl.subscription || '❌ ไม่มี',
      description: girl.description ? (girl.description.length > 20 ? girl.description.substring(0, 20) + '...' : girl.description) : '❌ ไม่มี',
      momoName: girl.momoName || '❌ ไม่มี',
      type: girl.type || '❌ ไม่มี',
      grades: girl.grades || '❌ ไม่มี'
    })));
    
  } catch (error) {
    console.error('❌ ไม่สามารถแสดงตารางข้อมูล:', error);
  }
};
